// // close zoom image through keyboard
// // document.addEventListener('DOMContentLoaded', function() {
// //     var closeButton = document.querySelector('.pswp__button--close');
// //     function simulateEscapeKeyPress() {
// //         var escapeEvent = new KeyboardEvent('keydown', {
// //             key: 'Escape',
// //             keyCode: 27
// //         });
// //         document.dispatchEvent(escapeEvent);
// //     }
// //     closeButton.addEventListener('click', function() {
// //         simulateEscapeKeyPress();
// //     });
// // });
// Function to zoom in
// function zoomIn() {
//     var images = document.querySelectorAll('.pswp__item img.pswp__img');
//     images.forEach(function(img) {
//         var scale = parseFloat(img.style.transform.replace('scale(', '').replace(')', '')) || 1;
//         img.style.transform = 'scale(' + (scale + 0.1) + ')';
//     });
// }

// // Function to zoom out
// function zoomOut() {
//     var images = document.querySelectorAll('.pswp__item img.pswp__img');
//     images.forEach(function(img) {
//         var scale = parseFloat(img.style.transform.replace('scale(', '').replace(')', '')) || 1;
//         img.style.transform = 'scale(' + (scale - 0.1) + ')';
//     });
// }

// // Create zoom in button
// var zoomInButton = document.createElement('button');
// zoomInButton.textContent = 'Zoom In';
// zoomInButton.addEventListener('click', zoomIn);

// // Create zoom out button
// var zoomOutButton = document.createElement('button');
// zoomOutButton.textContent = 'Zoom Out';
// zoomOutButton.addEventListener('click', zoomOut);

// // Find the main UI bar container
// var uiContainer = document.querySelector('.pswp__ui');

// // Append buttons to the main UI bar container
// uiContainer.appendChild(zoomInButton);
// uiContainer.appendChild(zoomOutButton);

// document.addEventListener('DOMContentLoaded', function() {
//     var closeButton = document.querySelector('.pswp__button--close');
//     var prevButton = document.querySelector('.pswp__button--prev');
//     var nextButton = document.querySelector('.pswp__button--next');
    
//     function simulateKeyPress(key) {
//         var event = new KeyboardEvent('keydown', {
//             key: key,
//             keyCode: key == 'Escape' ? 27 : key == 'ArrowLeft' ? 37 : 39 // Escape, left arrow, or right arrow key
//         });
//         document.dispatchEvent(event);
//     }
    
//     closeButton.addEventListener('click', function() {
//         simulateKeyPress('Escape');
//     });

//     prevButton.addEventListener('click', function() {
//         simulateKeyPress('ArrowLeft');
//     });

//     nextButton.addEventListener('click', function() {
//         simulateKeyPress('ArrowRight');
//     });
// });

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var targetNode = document.getElementById('sidebar-cart');
var cartBtn = document.getElementById('cartBtn');
if (targetNode && cartBtn) {
    var config = { attributes: true, attributeFilter: ['aria-hidden'] };
    var callback = function(mutationsList, observer) {
        for(var mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
                var ariaHiddenValue = targetNode.getAttribute('aria-hidden');
                cartBtn.setAttribute('aria-expanded', ariaHiddenValue === 'true' ? 'false' : 'true');
            }
        }
    };
    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

//Remove tabindex from slideshow conatiner and observe aria-controls of dot button
if (!window.location.href.startsWith("https://www.caratco.com/pages/cartier")) {
  window.onload = function() {
      var slideshowContainer = document.getElementById("slideshowconatiner");
      var slideshowSlides = document.querySelectorAll('.Slideshow__Slide.Carousel__Cell');
      var dotButtons = document.querySelectorAll('.dot');
      var pageDots = document.querySelector('.flickity-page-dots');
  
      if (slideshowContainer) {
          slideshowContainer.removeAttribute("tabindex");
      }
  
      if (slideshowSlides.length > 0 && dotButtons.length > 0 && pageDots) {
          slideshowSlides.forEach((slide, index) => {
              slide.setAttribute('role', 'tabpanel');
              if (dotButtons[index]) {
                  const slideId = slide.getAttribute('id');          
                  dotButtons[index].setAttribute('aria-controls', slideId);
              }
          });
  
          dotButtons.forEach(button => {
              const isSelected = button.classList.contains('is--selected');
              button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
              button.setAttribute('role', 'tab');
          });
  
          pageDots.setAttribute('role', 'tablist');
          var pageDotItems = pageDots.querySelectorAll('li');
          pageDotItems.forEach(item => {
                item.setAttribute('role', 'presentation');
          });
      }
  };
}

// Provided aria-selected attribute to the carousle button
const dotButtons = document.querySelectorAll('.dot');
if (dotButtons.length > 0) {
    dotButtons.forEach(button => {
        const observer1 = new MutationObserver(mutationsList => {
            mutationsList.forEach(mutation => {
                if (mutation.attributeName === 'class') {
                    button.setAttribute('aria-selected', button.classList.contains('is-selected').toString());
                }
            });
        });
        observer1.observe(button, { attributes: true });
    });
}

//provide aria-label to dot buttons
document.addEventListener("DOMContentLoaded", function() {
  var buttons = document.querySelectorAll('.flickity-page-dots button');
  buttons.forEach(function(button, index) {
    button.setAttribute('aria-label', 'Slide ' + (index + 1));
  });
});

//On page load aria-selected="true" is provided to the dot buttons
document.addEventListener("DOMContentLoaded", function() {
    var buttons = document.querySelectorAll('.flickity-page-dots button.dot');
    buttons.forEach(function(button) {
        if (button.classList.contains('is-selected')) {
            button.setAttribute('aria-selected', 'true');
        }
    });
});


//Skip link alternative code for keyboard
var skipLink = document.querySelector('a.PageSkipLink');
if (skipLink) {
    skipLink.addEventListener('click', function (e) {
        e.preventDefault();
        document.body.scrollTop = 110; // For Safari
        document.documentElement.scrollTop = 110; // For Chrome, Firefox, IE and Opera
        var mainElement = document.querySelector('main#main');
        if (mainElement) {
            mainElement.setAttribute('tabindex', '-1');
            mainElement.focus();
        }
    });
}

//View Image bookmark link
var viewImageButton = document.querySelector('a.Heading.Link.Link--secondary.u-h7.viewimage');
if (viewImageButton) {
    viewImageButton.addEventListener('click', function (e) {
        e.preventDefault();
        document.body.scrollTop = 110; // For Safari
        document.documentElement.scrollTop = 110; // For Chrome, Firefox, IE and Opera
        var selectedImage = document.querySelector('div.Product__SlideItem.Product__SlideItem--image.Carousel__Cell.is-selected');
        if (selectedImage) {
            selectedImage.focus();
        } else {
            console.error("Selected image element does not exist.");
        }
    });
}

// Flipp links
document.addEventListener("DOMContentLoaded", function() {
    const quickNav = document.querySelector('.Product__QuickNav');
    const moreInfoLink = quickNav ? quickNav.querySelector('a[href="#ProductAside"]') : null;
    const viewImagesLink = quickNav ? quickNav.querySelector('a[href="#ProductGallery"]') : null;

    if (quickNav && moreInfoLink && viewImagesLink) {
        function isFlipped() {
            return quickNav.classList.contains('is-flipped');
        }
        
        function setAttributes() {
            const isFlippedValue = isFlipped();
            moreInfoLink.setAttribute('aria-hidden', isFlippedValue ? 'true' : 'false');
            moreInfoLink.setAttribute('tabindex', isFlippedValue ? '-1' : '0');
            viewImagesLink.setAttribute('aria-hidden', isFlippedValue ? 'false' : 'true');
            viewImagesLink.setAttribute('tabindex', isFlippedValue ? '0' : '-1');
        }
        
        setAttributes();
        new MutationObserver(setAttributes).observe(quickNav, {attributes: true});
    }
});

// Set alt attributes for .pswp__img elements based on the ending of data-original-src
function setAltForPswpImages() {
    const pswpImages = document.querySelectorAll('.pswp__container .pswp__img');
    if (pswpImages.length > 0) {
        pswpImages.forEach(pswpImg => {
            const src = pswpImg.getAttribute('src');
            const correspondingProductImg = document.querySelector(`.Product__SlideItem img[data-original-src$="${getEndingSrc(src)}"]`);
            if (correspondingProductImg) {
                const alt = correspondingProductImg.getAttribute('alt');
                if (alt) {
                    pswpImg.setAttribute('alt', alt);
                }
            }
        });
    }
}
function getEndingSrc(src) {
    if (src && typeof src === 'string') {
        const lastEqualIndex = src.lastIndexOf('=');
        if (lastEqualIndex !== -1) {
            return src.substring(lastEqualIndex + 1);
        }
    }
    return src;
}
const observera = new MutationObserver(setAltForPswpImages);
observera.observe(document.body, { childList: true, subtree: true });
window.addEventListener('load', setAltForPswpImages);

// More information bookmark link
$('a.Heading.Link.Link--secondary.u-h7.moreinfo').click(function (e) {
    e.preventDefault();
    document.body.scrollTop = 110; // For Safari
    document.documentElement.scrollTop = 110; // For Chrome, Firefox, IE and Opera
    const collapsibleButton = $('button.Collapsible__Button.Heading.u-h6');
    if (collapsibleButton.length > 0) {
        collapsibleButton.focus();
    }
});

// Carousel dot links
document.addEventListener("DOMContentLoaded", function() {
    var links = document.querySelectorAll('.Product__SlideshowNavDot');
    if (links.length > 0) {
        function updateAriaSelected(link) {
            links.forEach(function(link) {
                link.setAttribute('aria-selected', link.classList.contains('is-selected'));
            });
        }
        updateAriaSelected();
        var observer = new MutationObserver(function(mutationsList, observer) {
            mutationsList.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    updateAriaSelected();
                }
            });
        });
        links.forEach(function(link) {
            observer.observe(link, { attributes: true });
        });
        links.forEach(function(link) {
            link.addEventListener('click', function() {
                links.forEach(function(link) {
                    link.classList.remove('is-selected');
                });
                link.classList.add('is-selected');
            });
        });
    }
});

// Scroll notification
var scrollToContentButton = document.getElementById('scroll_to_content');

if (scrollToContentButton) {
    scrollToContentButton.addEventListener('click', function() {
        var scrollNotification = document.getElementById('scroll_notification');

        if (scrollNotification) {
            scrollNotification.textContent = "Page scrolled";

            setTimeout(function() {
                scrollNotification.textContent = "";
                var mainH = document.querySelector('h2.SectionHeader.SectionHeader--center');
                if (mainH) {
                    mainH.setAttribute('tabindex', '-1');
                    mainH.focus();
                } else {
                    console.error("Heading element does not exist.");
                }
            }, 500);
        }
    });
}


document.addEventListener("DOMContentLoaded", function() {
    const cartBtn = document.getElementById("cartBtn");
    const sidebarCart = document.getElementById("sidebar-cart");
    if (cartBtn && sidebarCart) {
        cartBtn.addEventListener("click", function(event) {
            event.preventDefault();
            sidebarCart.classList.add("Drawer--open");
            setTimeout(function() {
                sidebarCart.focus();
            }, 500);
        });
    }
});

//Providing aria-expanded to the expandable links
//Code for providing esc functionality to expandable menu
document.addEventListener("DOMContentLoaded", function() {
	const parentElements = document.querySelectorAll('.Header__MainNav li[aria-haspopup=true]');
	var menuLinks = document.querySelectorAll('.Header__MainNav li[aria-haspopup=true] > a');
		menuLinks.forEach(function(menuLink) {
			menuLink.setAttribute('aria-expanded', 'false');
		});

	// Initialize a MutationObserver
	const observer = new MutationObserver(function(mutationsList) {
		mutationsList.forEach(function(mutation) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				// Get the parent element
				const parentElement = mutation.target;

				// Get all links inside the parent element
				const links = parentElement.querySelector('a');

				// Update the 'aria-expanded' attribute of each link based on the class
				links.setAttribute('aria-expanded', parentElement.classList.contains('is-expanded') ? 'true' : 'false');
			}
		});
	});

	// Observe mutations on each parent element
	parentElements.forEach(function(parentElement) {
		observer.observe(parentElement, { attributes: true });
	});

	// Add focusin event listener to each parent element
	parentElements.forEach(function(parentElement) {
		parentElement.addEventListener('focusin', function(event) {
			// Get all links inside the parent element
			const links = parentElement.querySelector('a');

			// Update the 'aria-expanded' attribute of each link
			links.setAttribute('aria-expanded', 'true');
		});
	});
	// Add keydown event listener to menu container
	const menuContainer = document.querySelector('.Header__MainNav');
	menuContainer.addEventListener('keydown', function(event) {
		if (event.key === 'Tab') {
			const focusedElement = document.activeElement;

			// Check if the focused element has class 'is-expanded'
			if (focusedElement.closest('.is-expanded')) {
				const parentLink = focusedElement.closest('.is-expanded');
				const anchorChild = parentLink.querySelector('a');
				anchorChild.setAttribute('aria-expanded', 'false');
			}
		}
		else if (event.key === 'Escape') {
			// Get the currently focused element
			const focusedElement = document.activeElement;
		
			// Check if the focused element is within a submenu
			if (focusedElement.closest('.is-expanded')) {
		
				// Find the parent menu link
				const parentLink = focusedElement.closest('.is-expanded');
				const anchorChild = parentLink.querySelector('a');
				anchorChild.setAttribute('aria-expanded', 'false');
			
				// Focus the parent menu link
				anchorChild.focus();
			
				setTimeout(()=>{
				focusedElement.closest('.is-expanded').classList.remove('is-expanded');
				anchorChild.nextElementSibling.setAttribute('aria-hidden', 'true');}, 50);
			}
		}
	});
});


document.addEventListener("DOMContentLoaded", function() {
    const productSlideItems = document.querySelectorAll('.Product__SlideItem.Product__SlideItem--image.Carousel__Cell[role="button"]');

    if (productSlideItems.length > 0) {
        productSlideItems.forEach(function(productSlideItem) {
            productSlideItem.addEventListener("keydown", function(event) {
                if (event.key === "Enter") {
                    productSlideItem.click();
                }
            });
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Tab') {
            const focusableElements = document.querySelectorAll('.pswp__button:not([disabled])');
            if (focusableElements.length > 0) {
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            if (!event.shiftKey && document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            } else if (event.shiftKey && document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            }
          }
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const prevButton = document.querySelector('.pswp__button--prev');
    const nextButton = document.querySelector('.pswp__button--next');

    if (prevButton && nextButton) {
        function focusOnPrevButton() {
            prevButton.focus();
        }
        function focusOnNextButton() {
            nextButton.focus();
        }
        function handleButtonMutation(mutationsList) {
            mutationsList.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
                    const isNextButtonDisabled = nextButton.hasAttribute('disabled');
                    const isPrevButtonDisabled = prevButton.hasAttribute('disabled');

                    if (isNextButtonDisabled && !isPrevButtonDisabled) {
                        focusOnPrevButton();
                    } else if (isPrevButtonDisabled && !isNextButtonDisabled) {
                        focusOnNextButton();
                    }
                }
            });
        }

        const observer5 = new MutationObserver(handleButtonMutation);
        const config = { attributes: true };

        observer5.observe(nextButton, config);
        observer5.observe(prevButton, config);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var prevButton = document.querySelector('.pswp__button--prev');
    var nextButton = document.querySelector('.pswp__button--next');

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', function () {
        announceStatusMessage('Previous slide updated');
    });

    nextButton.addEventListener('click', function () {
        announceStatusMessage('Next slide updated');
    });
  }
    function announceStatusMessage(message) {
        var statusMessage = document.getElementById('statusMessage');
        statusMessage.textContent = message;
        statusMessage.setAttribute('aria-live', 'assertive');
        setTimeout(function () {
            statusMessage.textContent = '';
            statusMessage.removeAttribute('aria-live');
        }, 500);
    }
});

window.addEventListener('DOMContentLoaded', (event) => {
    const slideshowContainer = document.getElementById('slideshowconatiner');
  if(slideshowContainer){
    var prevButton = slideshowContainer.querySelector('.flickity-prev-next-button.previous');
    var nextButton = slideshowContainer.querySelector('.flickity-prev-next-button.next');
  }
    if(prevButton){
    prevButton.setAttribute('aria-label', 'previous slide');
    prevButton.setAttribute('tabindex', '-1');
    prevButton.setAttribute('aria-hidden', 'true');
    }
    if(nextButton){
    nextButton.setAttribute('aria-label', 'next slide');
    nextButton.setAttribute('tabindex', '-1');
    nextButton.setAttribute('aria-hidden', 'true');
    }
});